


























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import VueInfiniteLoading from 'vue-infinite-loading';
import { to } from '@tencent/wphk-base-utils';
import Pagination, { PageResult } from './business';
import { MerchantState } from '@tencent/wphk-components-wecoupon';
import { ReceivedCouponListType } from '@/types/we-coupons';

/**
 * 分页组件
 * 主要实现功能：
 * 1、下拉触底时触发拉取分页
 * 2、管理分页数据，自动计算offset、limt
 * 3、过滤重复数据
 */
@Component({
  components: {
    VueInfiniteLoading,
  },
})
export default class PageNav<T> extends Vue {
  /**
   * 每页展示信息个数
   */
  @Prop({ default: 8 }) public pageSize!: number;

  /**
   * 分页数据查询，由业务提供
   */
  @Prop() queryPage!: (offset: number, limit: number) => Promise<PageResult<T>>;

  /**
   * 数据项比较，相同数据过滤掉，由业务提供，不传时不做数据过滤
   */
  @Prop() compareData?: (valueA: T, valueB: T) => boolean = undefined;

  /**
   * 已领取的优惠券couponId列表
   */
  @Prop({ default: () => [] }) receivedCouponIdList!: ReceivedCouponListType;

  /**
   * 分页处理对象
   */
  pageObj = new Pagination(this.pageSize);

  /**
   * 数据项列表
   */
  dataList: T[] = [];

  /**
   * 监听已领取优惠券列表
   * 然后修改总数据dataList的相应coupon属性
   */
  @Watch('receivedCouponIdList')
  onReceivedCouponIdListChanged() {
    this.dataList.forEach((item) => {
      // @ts-ignore
      const receiveCoupon = this.receivedCouponIdList.find(receivedCoupon => receivedCoupon.couponId === item.couponId);
      if (receiveCoupon) {
        // @ts-ignore
        item.state = MerchantState.Got;
        // @ts-ignore
        item.userScid = receiveCoupon.userScid;
      };
    });
  }

  /**
   * 更新数据
   */
  updateData(data: T[]) {
    const { compareData } = this;
    // 过滤掉重复数据
    data.forEach((item) => {
      if (!compareData || !this.dataList.find(o => compareData(o, item))) {
        this.dataList.push(item);
      }
    });
  }
  /**
   * 查询数据
   */
  async query() {
    const { offset, limit } = this.pageObj.getQueryParams();
    const [err, result] = await to(this.queryPage(offset, limit));
    if (err) {
      throw err;
    }

    this.pageObj.update(result!);
    this.updateData(result!.dataList);
  }

  /**
   * 下拉触底分页查询
   */
  async handleInfinite(infiniter) {
    const [err] = await to(this.query());
    if (err) {
      infiniter.error();
    }
    if (this.dataList.length > 0) {
      infiniter.loaded();
    }
    if (!this.pageObj.hasNextPage) {
      infiniter.complete();
      this.$emit('complete');
    }
  }

  mounted() {
    // this.query();
  }
}
